import styled from 'styled-components'

export default styled.h1`
	font-size: 3rem;
	text-align: center;
	${props => (props.margin ? `margin: ${props.margin}px` : '')};
`



// WEBPACK FOOTER //
// ./src/primitives/H1.js